import { render, staticRenderFns } from "./ClientAnalytics.vue?vue&type=template&id=05f18d4e&"
import script from "./ClientAnalytics.vue?vue&type=script&lang=js&"
export * from "./ClientAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./ClientAnalytics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports